import { Action, createReducer, on } from '@ngrx/store';

import { loadUserDataSuccessAction, loadUserInfoSuccessAction } from '@app/store/actions/global.actions';
import { UserInfo } from '@app/modules/core/interfaces/user';

export const initialState: UserInfo = {} as UserInfo;

const featureReducer = createReducer(
  initialState,
  on(loadUserDataSuccessAction, (state, { user }) => {
    return { ...state, ...user };
  }),
  on(loadUserInfoSuccessAction, (state, { userInfo }) => {
    return { ...state, ...userInfo };
  })
);

export const userReducer = (state: UserInfo, action: Action): UserInfo => {
  return featureReducer(state, action);
};
